
const validateInput = (setValidation, validation, inputType, value) => {
  if (inputType === 'deadline') {
    setValidation({
      ...validation,
      deadline: isNaN(Date.parse(value))
    });
  } else if (inputType === 'appraiser') {
    const isAppraiserInValid =
    !value || !(!!value.empid && !!value.name && !!value.address);

    setValidation({
      ...validation,
      appraiser: isAppraiserInValid
    });
  } else if (inputType === 'category') {
    const isCategoryValid =
    !value || !(!!value.account_id && !!value.category_id && !! value.category_name);

    setValidation({
      ...validation,
      category: isCategoryValid
    });
  } else {
    setValidation({
      ...validation,
      [inputType]: value.length === 0
    });
  }
};

const validateAllInputs = (setValidation, { name, description, deadline, appraiser, category }) => {
  const isAppraiserInValid =
    !appraiser || !(!!appraiser.empid && !!appraiser.name && !!appraiser.address);
  const isCategoryValid =
    !category || !(!!category.account_id && !!category.category_id && !! category.category_name);

  if (name.length === 0 || description.length === 0 || category.length === 0 ||
    isNaN(Date.parse(deadline)) || isAppraiserInValid) {
    setValidation({
      name: name.length === 0,
      description: description.length === 0,
      deadline: isNaN(Date.parse(deadline)),
      appraiser: isAppraiserInValid,
      category: isCategoryValid
    });

    return false;
  }

  return true;
};

export {
  validateInput,
  validateAllInputs
};
